export function evaluateCategoryTicketPackages(categoryIds, tickets, ticketsPerCategory, maxPackages) {
  if (!categoryIds.length || !tickets.length) {
    return { status: 'invalid' }
  }

  const counts = categoryIds.map(categoryId =>
    tickets.filter(
      ticket =>
        ticket.organizationItemCategory &&
        String(ticket.organizationItemCategory.id) === String(categoryId),
    ).length,
  )
  const categorizedTicketCount = counts.reduce((total, count) => total + count, 0)
  if (categorizedTicketCount !== tickets.length) {
    return { status: 'invalid' }
  }

  const packages = Math.ceil(Math.max(...counts) / ticketsPerCategory)
  if (packages > maxPackages) {
    return { status: 'limit' }
  }

  const requiredPerCategory = packages * ticketsPerCategory
  const missing = counts.reduce((total, count) => total + requiredPerCategory - count, 0)

  return missing ? { status: 'incomplete', missing } : { status: 'complete', packages }
}
